var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetup = function SvgSetup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.655 2.544 1.68.065 1.048 1.047-.063.843-1.285 1.285v.951l.635.635h.952l1.3-1.3h.876l.926.927.146 1.743-2.002 2.002-3.548-.147-3.44 3.457-.71-.705 3.751-3.77 3.55.147 1.364-1.363-.077-.916-.375-.375h-.047l-1.3 1.3h-1.78l-1.22-1.22V5.37L9.35 4.054l.001-.016-.445-.446-.853-.033-1.37 1.37.207 3.61-3.778 3.76-.706-.708 3.46-3.444L5.66 4.54l1.995-1.996Z",
    fill: "currentColor"
  })));
};
export default SvgSetup;